module.exports = __webpack_public_path__ + "img/NR.bbc94de9.svg";